import React from "react";
import Row2 from "./Row2";

function Row2View() {
  return (
    <div className="home">
      <div className="home__heading">Students are viewing</div>
      <div className="home__rows">
        <Row2
          title="The Complete 2021 Web Development Bootcamp"
          instructorName="Dr. Angela Yu"
          stars={4.5}
          comments={143688}
          ratings={4.7}
          price="₹385"
          image="https://img-c.udemycdn.com/course/240x135/1565838_e54e_12.jpg"
          isBestSeller
        />
        <Row2
          title="Front End Web Development Ultimate Course 2021"
          instructorName="Learn Tech Plus"
          stars={4.5}
          comments={6914}
          ratings={4.3}
          price="₹450"
          image="https://img-c.udemycdn.com/course/240x135/1691862_eba9_3.jpg"
        />
        <Row2
          title="2021 Complete Python Bootcamp From Zero to Hero in Python"
          instructorName="Jose Portilla"
          stars={4.5}
          comments={376333}
          ratings={4.6}
          price="₹8640"
          image="https://img-c.udemycdn.com/course/240x135/567828_67d0.jpg"
        />
        <Row2
          title="The Web Developer Bootcamp 2021"
          instructorName="Colt Steele"
          stars={4.5}
          comments={211386}
          ratings={4.7}
          price="₹385"
          image="https://img-c.udemycdn.com/course/240x135/625204_436a_3.jpg"
          isBestSeller
        />
        <Row2
          title="React - The Complete Guide (incl Hooks, React Router, Redux)"
          instructorName="Academind by Maximilian Schwarzmüller, M..."
          stars={4.5}
          comments={121110}
          ratings={4.7}
          price="₹1200"
          image="https://img-c.udemycdn.com/course/240x135/1362070_b9a1_2.jpg"
        />
        <Row2
          title="The Complete JavaScript Course 2021: From Zero to Expert!"
          instructorName="Jonas Schmedtmann"
          stars={4}
          comments={111860}
          ratings={4.0}
          price="₹385"
          image="https://img-c.udemycdn.com/course/240x135/851712_fc61_6.jpg"
          isBestSeller
        />
        <Row2
          title="SQL Masterclass: SQL for Data Analytics"
          instructorName="Start-Tech Academy"
          stars={4.5}
          comments={7714}
          ratings={4.5}
          price="₹8200"
          image="https://img-c.udemycdn.com/course/240x135/2120874_a33d_2.jpg"
          isBestSeller
        />
        <Row2
          title="Python Network Programming for Network Engineers (Python 3)"
          instructorName="David Bombal, Experts with David Bombal"
          stars={4.5}
          comments={6511}
          ratings={4.7}
          price="₹385"
          image="https://img-c.udemycdn.com/course/240x135/1554180_150a_2.jpg"
        />
        <Row2
          title="Microsoft Excel - Excel from Beginner to Advanced"
          instructorName="Kyle Pew, Office Newb"
          stars={4.5}
          comments={244527}
          ratings={4.6}
          price="₹385"
          image="https://img-c.udemycdn.com/course/240x135/793796_0e89.jpg"
          isBestSeller
        />
        <Row2
          title="Ultimate AWS Certified Solutions Architect Associate 2021"
          instructorName="Stephane Maarek | AWS Certified Cloud Prac..."
          stars={4.5}
          comments={86512}
          ratings={4.7}
          price="₹500"
          image="https://img-c.udemycdn.com/course/240x135/2196488_8fc7_7.jpg"
        />
        <Row2
          title="Java Programming Masterclass covering Java 11 & Java 17"
          instructorName="Tim Buchalka, Tim Buchalka's Learn Program..."
          stars={4.5}
          comments={145822}
          ratings={4.6}
          price="₹500"
          image="https://img-c.udemycdn.com/course/240x135/533682_c10c_4.jpg"
        />
        <Row2
          title="Machine Learning A-Z™: Hands-On Python & R In Data Science"
          instructorName="Kirill Eremenko, Hadelin de Ponteves, SuperDataScience Support, Ligency Team"
          stars={4.5}
          comments={149345}
          ratings={4.6}
          price="₹385"
          image="https://img-c.udemycdn.com/course/240x135/950390_270f_3.jpg"
        />
        <Row2
          title="Web Development Masterclass - Complete Certificate Course"
          instructorName="YouAccel Training"
          stars={3.5}
          comments={6886}
          ratings={3.8}
          price="₹385"
          image="https://img-c.udemycdn.com/course/240x135/965528_737d_6.jpg"
        />
        <Row2
          title="Build Responsive Real-World Websites with HTML and CSS"
          instructorName="Jonas Schmedtmann"
          stars={4.5}
          comments={57382}
          ratings={4.6}
          price="₹855"
          image="https://img-c.udemycdn.com/course/240x135/437398_46c3_10.jpg"
        />
        <Row2
          title="Automate the Boring Stuff with Python Programming"
          instructorName="Al Sweigart"
          stars={4.5}
          comments={91714}
          ratings={4.6}
          price="₹385"
          image="https://img-c.udemycdn.com/course/240x135/543600_64d1_4.jpg"
          isBestSeller
        />
        <Row2
          title="The Complete Digital Marketing Course - 12 Courses in 1"
          instructorName="Rob Percival, Daragh Walsh, Codestars by Ro..."
          stars={4.5}
          comments={137308}
          ratings={4.5}
          price="₹418"
          image="https://img-c.udemycdn.com/course/240x135/914296_3670_8.jpg"
        />
      </div>
    </div>
  );
}

export default Row2View;
